import { render, staticRenderFns } from "./SharedTipsInfoIcon.vue?vue&type=template&id=4dbd2b3f&scoped=true&"
import script from "./SharedTipsInfoIcon.vue?vue&type=script&lang=js&"
export * from "./SharedTipsInfoIcon.vue?vue&type=script&lang=js&"
import style0 from "./SharedTipsInfoIcon.vue?vue&type=style&index=0&id=4dbd2b3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbd2b3f",
  null
  
)

export default component.exports